// extracted by mini-css-extract-plugin
module.exports = {"container":"singlecellChart-module__container___2qHZL","overlay":"singlecellChart-module__overlay___3Hkh9"};